import { Layout } from "@/components/Layout";
import { Reveal } from "@/components/Reveal";
import { Link } from "react-router-dom";
import { WHY_EDROY, CONTACT } from "@/data/content";

const ARCHITECTURE =
  "https://images.unsplash.com/photo-1699465301322-362016624dd7?auto=format&fit=crop&w=1600&q=80";

export default function About() {
  return (
    <Layout>
      <section className="pt-36 pb-16 lg:pt-44" data-testid="about-hero">
        <div className="container-editorial">
          <Reveal>
            <div className="eyebrow">About the Practice</div>
          </Reveal>
          <Reveal delay={0.05}>
            <h1 className="font-display text-5xl md:text-7xl mt-6 leading-[1.02] tracking-tight max-w-4xl">
              A consulting-led HR and workforce solutions practice — <span className="italic text-gold">execution-driven</span>.
            </h1>
          </Reveal>
        </div>
      </section>

      {/* HERO IMAGE + PHILOSOPHY */}
      <section className="py-8 lg:py-12">
        <div className="container-editorial">
          <Reveal>
            <div className="aspect-[21/9] overflow-hidden border border-[#E0DCD3] bg-ivory-surface">
              <img src={ARCHITECTURE} alt="Architectural pattern" className="w-full h-full object-cover" />
            </div>
          </Reveal>
        </div>
      </section>

      <section className="py-16 lg:py-24">
        <div className="container-editorial grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <Reveal>
              <div className="eyebrow">Focus of the practice</div>
              <p className="mt-6 font-display text-3xl md:text-4xl leading-tight tracking-tight text-charcoal">
                Solving complex talent, workforce, and organizational challenges for enterprises, GCCs, startups, and
                growth-stage organizations.
              </p>
            </Reveal>
            <Reveal delay={0.1}>
              <div className="hairline mt-10 pt-8">
                <div className="eyebrow">Founder</div>
                <div className="font-display text-2xl mt-3">{CONTACT.founder}</div>
                <div className="text-sm text-slate2 mt-1">{CONTACT.founderTitle}</div>
                <div className="mt-4 text-sm text-slate2">
                  <a href={`mailto:${CONTACT.email}`} className="editorial-link" data-testid="about-email">
                    {CONTACT.email}
                  </a>
                </div>
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-7">
            <Reveal delay={0.15}>
              <p className="text-lg leading-relaxed text-slate2">
                With over two decades of experience across Talent Acquisition, Talent Management, HR Consulting,
                Workforce Strategy, and HR Technology — combining strategic advisory with strong execution capability.
              </p>
            </Reveal>

            <Reveal delay={0.2}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-12">
                {WHY_EDROY.map((d, i) => (
                  <div key={d.title} className="border-t border-[#E0DCD3] pt-6">
                    <div className="eyebrow">{String(i + 1).padStart(2, "0")}</div>
                    <div className="font-display text-2xl mt-3">{d.title}</div>
                    <p className="text-sm mt-3 text-slate2 leading-relaxed">{d.body}</p>
                  </div>
                ))}
              </div>
            </Reveal>

            <Reveal delay={0.25}>
              <div className="mt-14 flex flex-wrap gap-4">
                <Link to="/services" className="btn-primary" data-testid="about-cta-services">The five pillars</Link>
                <Link to="/contact" className="btn-outline" data-testid="about-cta-contact">Open a conversation</Link>
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </Layout>
  );
}
